<div class="modal-header ca-overview-header">
	<div>
		<h4 class="modal-title mb-0" id="ca-overview-title">Account overview</h4>
		<div class="text-muted small" *ngIf="customerTitle">{{ customerTitle }}</div>
	</div>
	<button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('close')">
		<span aria-hidden="true" class="fa fa-close"></span>
	</button>
</div>

<div class="modal-body ca-overview-body">
	<div *ngIf="loading" class="text-center py-5">
		<mat-spinner diameter="40"></mat-spinner>
		<p class="text-muted small mt-2 mb-0">Loading balance, cards, and open items…</p>
	</div>

	<div *ngIf="!loading && loadError" class="alert alert-danger mb-0" role="alert">
		{{ loadError }}
	</div>

	<ng-container *ngIf="!loading && !loadError && arData">
		<section class="ca-section ca-summary">
			<h5 class="ca-section-title">Account balance &amp; aging</h5>
			<div class="ca-stat-grid">
				<div class="ca-stat ca-stat-balance">
					<span class="ca-stat-label">Balance</span>
					<span class="ca-stat-value">{{ aged.balance | currency }}</span>
				</div>
				<div class="ca-stat">
					<span class="ca-stat-label">Future</span>
					<span class="ca-stat-value">{{ aged.future | currency }}</span>
				</div>
				<div class="ca-stat">
					<span class="ca-stat-label">Current</span>
					<span class="ca-stat-value">{{ aged.current | currency }}</span>
				</div>
				<div class="ca-stat" [class.ca-stat-due]="+(aged.due || 0) > 0">
					<span class="ca-stat-label">30 day</span>
					<span class="ca-stat-value">{{ aged.due | currency }}</span>
				</div>
				<div class="ca-stat" [class.ca-stat-due]="+(aged.overdue || 0) > 0">
					<span class="ca-stat-label">60 day</span>
					<span class="ca-stat-value">{{ aged.overdue | currency }}</span>
				</div>
				<div class="ca-stat" [class.ca-stat-due]="+(aged.overdue1 || 0) > 0">
					<span class="ca-stat-label">90 day</span>
					<span class="ca-stat-value">{{ aged.overdue1 | currency }}</span>
				</div>
				<div class="ca-stat" [class.ca-stat-due]="+(aged.overdue2 || 0) > 0">
					<span class="ca-stat-label">120+</span>
					<span class="ca-stat-value">{{ aged.overdue2 | currency }}</span>
				</div>
			</div>
			<div class="ca-meta-row mt-2">
				<span class="ca-meta" *ngIf="arData.creditlimit != null"><small>Credit limit</small>{{ arData.creditlimit | currency }}</span>
				<span class="ca-meta" *ngIf="termsLabel"><small>Terms</small>{{ termsLabel }}</span>
				<span class="ca-meta" *ngIf="arData.name"><small>AR name</small>{{ arData.name }}</span>
			</div>
		</section>

		<mat-divider class="my-3"></mat-divider>

		<section class="ca-section">
			<h5 class="ca-section-title">Cards on file</h5>
			<p class="text-muted small mb-2" *ngIf="!cards.length">No saved cards for this customer.</p>
			<ul class="list-group ca-card-list" *ngIf="cards.length">
				<li class="list-group-item d-flex justify-content-between align-items-center flex-wrap" *ngFor="let card of cards">
					<div>
						<span class="ca-card-line">{{ displayCardLine(card) }}</span>
						<span class="text-muted small d-block" *ngIf="card.name">{{ card.name }}</span>
					</div>
					<span class="badge bg-primary rounded-pill" *ngIf="card.default">Default</span>
					<span class="badge bg-secondary rounded-pill ms-1" *ngIf="card.branchcode">Br {{ card.branchcode }}</span>
				</li>
			</ul>
		</section>

		<mat-divider class="my-3"></mat-divider>

		<section class="ca-section">
			<div class="d-flex justify-content-between align-items-baseline flex-wrap gap-2 mb-2">
				<h5 class="ca-section-title mb-0">Open AR (invoices &amp; debits)</h5>
				<span class="small text-muted">Unsettled · total {{ openDebitTotal() | currency }}</span>
			</div>
			<p class="text-muted small mb-2" *ngIf="!openDebits.length">No open debit documents.</p>
			<div class="table-responsive ca-table-wrap" *ngIf="openDebits.length">
				<table class="table table-sm table-hover mb-0">
					<thead class="table-light">
						<tr>
							<th>Type</th>
							<th>Date</th>
							<th>Doc #</th>
							<th>Order</th>
							<th>Salesperson</th>
							<th>Reference</th>
							<th class="text-center">Card</th>
							<th class="text-end">Amount</th>
							<th class="text-end">Open</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let row of openDebits; trackBy: trackByTrans">
							<td class="text-nowrap">{{ row.typename }}</td>
							<td class="text-nowrap">{{ row.trandate }}</td>
							<td class="text-nowrap">{{ row.transno }}</td>
							<td class="text-nowrap">{{ +row.orderno ? row.orderno : '—' }}</td>
							<td class="text-nowrap">{{ salespersonDisplay(row) }}</td>
							<td class="ca-col-ref">{{ row.reference }}</td>
							<td class="text-center" [matTooltip]="cardColumnTooltip(row)">
								<span *ngIf="hasLinkedCardPayment(row)" class="ca-card-badge">card</span>
								<span *ngIf="!hasLinkedCardPayment(row)" class="text-muted">—</span>
							</td>
							<td class="text-end ca-amt" [class.ca-neg]="+row.total < 0">{{ row.total | currency }}</td>
							<td class="text-end ca-amt ca-open" [class.ca-neg]="+row.leftto < 0">{{ row.leftto | currency }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</section>

		<mat-divider class="my-3"></mat-divider>

		<section class="ca-section">
			<div class="d-flex justify-content-between align-items-baseline flex-wrap gap-2 mb-2">
				<h5 class="ca-section-title mb-0">Open credits &amp; payments</h5>
				<span class="small text-muted">Unsettled · total {{ openCreditTotal() | currency }}</span>
			</div>
			<p class="text-muted small mb-2" *ngIf="!openCredits.length">No unapplied credits or payments.</p>
			<div class="table-responsive ca-table-wrap" *ngIf="openCredits.length">
				<table class="table table-sm table-hover mb-0">
					<thead class="table-light">
						<tr>
							<th>Type</th>
							<th>Date</th>
							<th>Doc #</th>
							<th>Salesperson</th>
							<th>Reference</th>
							<th class="text-center">Card</th>
							<th class="text-end">Amount</th>
							<th class="text-end">Open</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let row of openCredits; trackBy: trackByTrans">
							<td class="text-nowrap">{{ row.typename }}</td>
							<td class="text-nowrap">{{ row.trandate }}</td>
							<td class="text-nowrap">{{ row.transno }}</td>
							<td class="text-nowrap">{{ salespersonDisplay(row) }}</td>
							<td class="ca-col-ref">{{ row.reference }}</td>
							<td class="text-center" [matTooltip]="cardColumnTooltip(row)">
								<span *ngIf="hasLinkedCardPayment(row)" class="ca-card-badge">card</span>
								<span *ngIf="!hasLinkedCardPayment(row)" class="text-muted">—</span>
							</td>
							<td class="text-end ca-amt" [class.ca-neg]="+row.total < 0">{{ row.total | currency }}</td>
							<td class="text-end ca-amt ca-open" [class.ca-neg]="+row.leftto < 0">{{ row.leftto | currency }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</section>
	</ng-container>
</div>

<div class="modal-footer">
	<button type="button" mat-stroked-button color="primary" (click)="activeModal.close()">Close</button>
</div>
